// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.ImportProgressPopupAction.js" company="Izenda">
//  Copyright (c) 2018 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import { withHandlers } from 'recompose';
import { curry, map, forEach, find, every } from 'lodash/fp';
import ImportProgressItem from 'logic/models/Izenda.ImportProgressItem';
import fetcher from 'fetchers/Izenda.ImportFetcher';
import { ImportStatus as IMPORT_STATUS } from 'logic/data/Izenda.ImportConstants';

/**
 * On closing popup
 * @param {Object} props 
 * @param {Array} importProgressList 
 */
function onClosing(props: any, importProgressList: Array<any>) {
  props.onAccept(importProgressList);
}

/**
 * On cancel import process
 * @param {Object} props 
 * @param {Array} importProgressList 
 */
function onCancelImport(props: any, importProgressList: Array<any>) {
  const { store } = props;
  const data = map('id', importProgressList);
  return store.cancelImport(data).then(result => {
    setNewImportStatus(result, importProgressList);
  });
}

/**
 * Update import status
 * @param {Object} props 
 * @param {Array} importProgressList 
 */
function updateImportStatus(props: any, importProgressList: Array<any>) {
  const data = map('id', importProgressList);
  return fetcher.getImportStatus(data).then(result => {
    setNewImportStatus(result, importProgressList);
    return every(
      item => item.status === IMPORT_STATUS.SUCCESS.value || item.status === IMPORT_STATUS.FAILED.value,
      importProgressList
    );
  });
}

/**
 * Set new import status for each file
 * @param {Array} result 
 * @param {Array} importProgressList 
 */
function setNewImportStatus(result: Array<any>, importProgressList: Array<any>) {
  forEach(item => {
    const matchedItem = find(newItem => newItem.id === item.id, result);
    matchedItem && (item.status = matchedItem.status);
  }, importProgressList);
}

/**
 * Convert array file to import progress list
 * @param {Object} props 
 * @param {Array} fileList 
 */
function convertToImportProgressList(props: any, fileList: Array<any>): Array<ImportProgressItem> {
  return map(file => new ImportProgressItem(file), fileList);
}

export default withHandlers({
  onClosing: curry(onClosing),
  onCancelImport: curry(onCancelImport),
  updateImportStatus: curry(updateImportStatus),
  convertToImportProgressList: curry(convertToImportProgressList)
});



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/Import/Popup/Izenda.ImportProgressPopupAction.js